import React, { useMemo } from 'react'
import { Redirect } from 'react-router'
import { renderRoutes, RouteConfig } from 'react-router-config'
import { absRoutes, travelRoutes } from '@/utils'
import { usePermission } from './interceptors/permission'
import error from './error'
import admin from './admin'
import middleware from './middleware'
import user from './user'
import { useSelector } from '@/store'

export function addNotMatchRoute(routes: RouteConfig[]): RouteConfig[] {
  const newRoutes = routes.map((item) => {
    if (item.routes && item.routes.length > 0) {
      item.routes.push({
        path: '/*',
        component: () => <Redirect to="/ship/order/list" />,
        exact: true,
      })
      return { ...item, routes: addNotMatchRoute(item.routes) }
    } else {
      return item
    }
  })
  return newRoutes
}
export const routes = addNotMatchRoute(
  absRoutes([
    {
      path: '/',
      component() {
        return <Redirect to="/dashboard" />
      },
      exact: true,
    },
    ...error,
    ...middleware,
    ...user,
    ...admin,
  ])
)

const Router: React.FC = () => {
  const permissionInterceptor = usePermission()
  const countryCode = useSelector((state) => state?.auth?.userInfo?.countryCode)
  const routers = useMemo(() => {
    const interceptedRoutes = travelRoutes(routes, (route: RouteConfig) => {
      let interceptorRoute = route
      if (typeof route.interceptor === 'function') {
        interceptorRoute = route.interceptor(route, {})
      }
      // 国家展示过滤
      if (route.showCountryCodes && !route.showCountryCodes?.includes(countryCode)) {
        return null
      }

      // 国家展示过滤
      if (route.hideCountryCodes && route.hideCountryCodes?.includes(countryCode)) {
        return null
      }
      // 权限拦截
      interceptorRoute = permissionInterceptor(route)
      return interceptorRoute
    })

    return absRoutes(interceptedRoutes)
  }, [permissionInterceptor, countryCode])

  return renderRoutes(routers)
}

Router.displayName = 'Router'
export default Router
